<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ComboBox from 'dashboard/components-next/combobox/ComboBox.vue';
import { fieldRef, groupableFields } from './widgetConfig';

const props = defineProps({
  unit: { type: String, required: true },
  catalog: { type: Object, default: () => ({}) },
});

const groupBy = defineModel({ type: String, default: '' });

const { t } = useI18n();

// Etapa e Responsável só existem em Negociações.
const options = computed(() => [
  { value: 'label', label: t('COMMERCIAL_WIDGETS_DIALOG.GROUP_BY.LABEL') },
  ...(props.unit === 'deal'
    ? [
        {
          value: 'stage',
          label: t('COMMERCIAL_WIDGETS_DIALOG.GROUP_BY.STAGE'),
        },
        {
          value: 'responsible',
          label: t('COMMERCIAL_WIDGETS_DIALOG.GROUP_BY.RESPONSIBLE'),
        },
      ]
    : []),
  ...groupableFields(props.catalog, props.unit).map(field => ({
    value: `field:${fieldRef(field)}`,
    label: t('COMMERCIAL_WIDGETS_DIALOG.GROUP_BY.FIELD', { name: field.name }),
  })),
]);
</script>

<template>
  <div class="flex flex-col">
    <span class="mb-1 text-sm font-medium text-n-slate-12">
      {{ t('COMMERCIAL_WIDGETS_DIALOG.GROUP_BY.TITLE') }}
    </span>
    <ComboBox
      v-model="groupBy"
      :options="options"
      :placeholder="t('COMMERCIAL_WIDGETS_DIALOG.GROUP_BY.PLACEHOLDER')"
    />
    <p class="mt-1 mb-0 text-xs text-n-slate-11">
      {{ t('COMMERCIAL_WIDGETS_DIALOG.GROUP_BY.HINT') }}
    </p>
  </div>
</template>
